import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { Checkbox } from '../../../components/common/Checkbox/Checkbox';
import Spinner from '../../../components/common/Spinner';
import { dateNowString } from '../../../helpers/helperFunctions';
import { PRIVACY_POLICY, TERMS_OF_USE } from '../../../routes/routes';
import { H4, P2 } from '../../../styles/FontStyles';
import { Button, TermsWrapper } from '../../../styles/GlobalComponents';
import { useWindowWide } from '../../../helpers/wideScreen';
import { Agreement } from '../KycStyled';
import { approveKycTerms } from './KycAgreement.actions';
import { AnimatedDashboard } from '../../../components';
import { colors } from '../../../styles/GlobalStyles';
import { getContentBlock } from '../../../slices/content-block-slice';

const KycAgreement = ({ history }: RouteComponentProps) => {
  const { t } = useTranslation('kyc');

  const dispatch = useAppDispatch();
  const { contentBlock, loading } = useAppSelector(
    (state) => state.contentBlock
  );

  const kycLoading = useAppSelector((state) => state.kyc.loading);

  const [checkbox, setCheckbox] = useState(false);
  const [checkbox2, setCheckbox2] = useState(false);
  const [checkbox3, setCheckbox3] = useState(false);
  const [checkbox4, setCheckbox4] = useState(false);
  const [checkbox5, setCheckbox5] = useState(false);

  useEffect(() => {
    dispatch(getContentBlock({ contentBlockId: 117, languageId: 1 }));
  }, [dispatch]);

  const wide = useWindowWide(1000);
  const wide2 = useWindowWide(1800);

  const { user } = useAppSelector((state) => state.auth.userInfo);

  return (
    <AnimatedDashboard key={'kyc-agreement'}>
      <div
        style={{
          paddingBottom: !wide ? '150px' : '0',
          maxHeight: '90vh',
          overflow: 'scroll'
        }}
        className='noScrollBar'>
        {(loading || kycLoading) && <Spinner fullScreen={true} transparent />}

        <H4 center mb='40'>
          {t('agreement.title')}
        </H4>
        <TermsWrapper height='calc(100vh - 600px)'>
          <div
            dangerouslySetInnerHTML={{
              __html: contentBlock && contentBlock.content
            }}
          />
        </TermsWrapper>

        <div style={{ maxWidth: wide2 ? 1000 : 700 }}>
          <Agreement>
            <Checkbox
              margin={'0 20px 0 0'}
              checked={checkbox}
              onClick={() => setCheckbox(!checkbox)}
            />
            <P2>{t('agreement.checkbox1')}</P2>
          </Agreement>
          <Agreement>
            <Checkbox
              margin={'0 20px 0 0'}
              checked={checkbox2}
              onClick={() => setCheckbox2(!checkbox2)}
            />

            <P2>
              I understand I am entitled to update and correct the information
              and agree that this information could be held and processed by
              United One in accordance with our{' '}
              <a
                style={{ textDecoration: 'underline' }}
                href={PRIVACY_POLICY}
                target='_blank'
                rel='noreferrer'>
                {t('agreement.privacy_policy')}
              </a>{' '}
              {t('agreement.and')}{' '}
              <a
                style={{ textDecoration: 'underline' }}
                href={TERMS_OF_USE}
                target='_blank'
                rel='noreferrer'>
                {t('agreement.terms_and_condition')}
              </a>
              .
            </P2>
          </Agreement>
          <Agreement>
            <Checkbox
              margin={'0 20px 0 0'}
              checked={checkbox3}
              onClick={() => setCheckbox3(!checkbox3)}
            />

            <P2>
              I agree to receive content from United One (newsletter,
              advertising material, email updates)
            </P2>
          </Agreement>
          {user?.countryCode === 'JP' && (
            <>
              <Agreement>
                <Checkbox
                  margin={'0 20px 0 0'}
                  checked={checkbox4}
                  onClick={() => setCheckbox4(!checkbox4)}
                />

                <P2>{t('agreement.checkbox4')}</P2>
              </Agreement>

              <Agreement>
                <Checkbox
                  margin={'0 20px 0 0'}
                  checked={checkbox5}
                  onClick={() => setCheckbox5(!checkbox5)}
                />

                <P2>{t('agreement.checkbox5')}</P2>
              </Agreement>
            </>
          )}
        </div>
        <Button
          maxWidth={wide && '200px'}
          disabled={
            user?.countryCode === 'JP'
              ? !checkbox ||
                !checkbox2 ||
                !checkbox3 ||
                !checkbox4 ||
                !checkbox5
              : !checkbox || !checkbox2 || !checkbox3
          }
          onClick={() =>
            dispatch(approveKycTerms({ approvalDate: dateNowString, history }))
          }>
          {t('agreement.agree')}
        </Button>
      </div>
    </AnimatedDashboard>
  );
};

export default KycAgreement;
